import React from 'react';
import PropTypes from 'prop-types';
import {CircularProgress} from "@mui/material";

/**
 * Displays aggregated survey statistics for filtered personnel.
 * Similar to ActivityHeader "Top Rules" design but with survey metrics.
 *
 * @param {Object} statistics - Aggregate statistics object
 * @param {boolean} loading - Whether data is loading
 */
const SatisfactionStatistics = ({ statistics, loading }) => {
    // Format numbers with commas for readability
    const formatNumber = (num) => {
        if (num === null || num === undefined) return '-';
        return num.toLocaleString();
    };

    // Format percentages with 2 decimal places
    const formatPercentage = (num) => {
        if (num === null || num === undefined || isNaN(num)) return '-';
        return `${num.toFixed(2)}%`;
    };

    // Show loading state
    if (loading) {
        return (
            <div className="satisfactionStatistics">
                <div className="statisticsLoading">
                    <CircularProgress />
                </div>
            </div>
        );
    }

    // Show empty state if no data
    if (!statistics) {
        return null;
    }

    // Define statistics cards configuration
    const cards = [
        {
            title: 'Total Sent Surveys',
            value: formatNumber(statistics.totalSentSurveys),
            subtitle: null
        },
        {
            title: 'Total Responded Surveys',
            value: formatNumber(statistics.totalRespondedSurveys),
            subtitle: null
        },
        {
            title: 'Survey Response Rate',
            value: formatPercentage(statistics.surveyResponseRate),
            subtitle: null
        },
        {
            title: 'Total Positive Answers',
            value: formatNumber(statistics.totalPositiveAnswers),
            subtitle: null
        },
        {
            title: 'Total Answers',
            value: formatNumber(statistics.totalAnswers),
            subtitle: null
        },
        {
            title: 'Combined CPSS',
            value: formatPercentage(statistics.combinedCPSS),
            subtitle: null
        }
    ];

    return (
        <div className="satisfactionStatistics">
            <div className="statisticsCarousel">
                <div className="statisticsCards">
                    {cards.map((card, index) => (
                        <div key={index} className="statisticsCard">
                            <div className="cardTitle">{card.title}</div>
                            <div className="cardValue">{card.value}</div>
                            {card.subtitle && (
                                <div className="cardSubtitle">{card.subtitle}</div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

SatisfactionStatistics.propTypes = {
    statistics: PropTypes.shape({
        totalPersonnel: PropTypes.number,
        totalSentSurveys: PropTypes.number,
        totalRespondedSurveys: PropTypes.number,
        surveyResponseRate: PropTypes.number,
        totalPositiveAnswers: PropTypes.number,
        totalAnswers: PropTypes.number,
        combinedCPSS: PropTypes.number
    }),
    loading: PropTypes.bool
};

export default SatisfactionStatistics;
